(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cms-form-fields"] && !Shopify.designMode) return;
  try {
    // Friendly Captcha's invisible captcha guide, applied to every widget on the
  // page: show the widget when it needs a click, takes too long, errors or expires.
  (function () {
    var SHOW_AFTER_LONG_WAIT_MS = 5000;
    var timers = new WeakMap();

    function show(widget) {
      widget.classList.remove('cms-form__captcha--hidden');
    }

    document.addEventListener('frc:widget.statechange', function (event) {
      var widget = event.target.closest && event.target.closest('.cms-form__captcha');
      if (!widget) return;

      var state = event.detail.state;
      if (event.detail.mode === 'interactive') {
        show(widget);
      }
      if (state === 'requesting' && !timers.has(widget)) {
        timers.set(
          widget,
          setTimeout(function () {
            show(widget);
          }, SHOW_AFTER_LONG_WAIT_MS)
        );
      } else if (state === 'completed') {
        clearTimeout(timers.get(widget));
        timers.delete(widget);
      } else if (state === 'error' || state === 'expired') {
        show(widget);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-cart-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (evt) => {
    const clicked = evt.target
    if (typeof clicked?.dataset.cartAddSubscription === 'string') {
      const line = clicked.closest('[data-input-item]')
      line.classList.add('pending-subscription-update')
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: clicked.dataset.index,
          quantity: line.querySelector('[data-quantity-input]').value,
          selling_plan: clicked.dataset.subscriptionId
        })
      }).then(() => {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      })
    }
  })


  document.addEventListener('change', (evt) => {
    const changed = evt.target
    if (changed.tagName === 'SELECT' && typeof changed?.dataset.cartChooseSubscription === 'string') {
      const line = changed.closest('[data-input-item]')
      line.classList.add('pending-subscription-update')
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: changed.dataset.index,
          quantity: line.querySelector('[data-quantity-input]').value,
          selling_plan: changed.value
        })
      }).then(() => {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      })
    }
  })
  } catch(e) { console.error(e); }
})();

})();
